'use client'

import { cn } from '@/lib/utils'
import React from 'react'

interface INewScrollCardsProps {
  className?: string
  height?: string
  children: React.ReactNode
  numCards: number
  gap?: string
}

export function NewScrollCards({
  children,
  className,
  height,
  numCards,
  gap = '24px'
}: INewScrollCardsProps) {
  const childrenArray = React.Children.toArray(children)

  return (
    <ul
      id="cards"
      className={cn(
        'scroll-cards-container mx-auto w-full text-center md:static',
        className
      )}
      style={
        {
          '--numcards': numCards,
          '--card-height': height,
          '--card-margin': gap,
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: 'var(--card-margin)',
          gridTemplateRows: `repeat(${numCards}, var(--card-height))`,
          gridAutoFlow: 'row'
        } as React.CSSProperties
      }
    >
      {childrenArray.map((child, index) => (
        <li
          className="scroll-card sticky top-32 w-full flex-1"
          data-card
          id={`card_${index + 1}`}
          key={index}
          style={
            {
              '--index': index + 1,
              '--card-top-offset': '1.5em',
              paddingTop: `calc(var(--index) * var(--card-top-offset))`
            } as React.CSSProperties
          }
        >
          <div className="scroll-card-content origin-top overflow-hidden will-change-transform">
            {child}
          </div>
        </li>
      ))}
    </ul>
  )
}
